<script>
export default {
  name: 'HubPagination',
  props: {},
  data() {
    return {
      activePageIndex: null,
      pageCount: null,
    };
  },
  mounted() {
    // eslint-disable-next-line max-len
    this.activePageIndex = Array.from(this.$el.querySelectorAll('.hub-pagination__page-number')).indexOf(this.$el.querySelector('.hub-pagination__page-number--active')) + 1;
    this.pageCount = this.$el.querySelectorAll('.hub-pagination__page-number').length;
  },
  computed: {
    activePageModifier() {
      if (this.pageCount > 3) {
        return {
          'hub-pagination--hide-last-2': this.activePageIndex === 1 || this.activePageIndex === 2,
          'hub-pagination--hide-first-last': this.activePageIndex === 3,
          'hub-pagination--hide-first-2': this.activePageIndex === 4 || this.activePageIndex === 5,
        };
      }

      return null;
    },
  },
};
</script>
